import { Badge, Box, Button, createStyles, Group, Input, Radio, Stack, Text, Textarea, ThemeIcon } from '@mantine/core';

import { useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks';
// import { IconFile} from '@tabler/icons-react';
import CustomDatePicker from 'core/components/datePicker/CustomDatePicker';
import { ChannelBadge, FormInputWrapper, TagInput } from 'core/components/index';
import { SeasonModel } from 'core/models';
import { createSeason } from 'modules/Seasons/seasonSlice';
import { useEffect } from 'react';
import { useState } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AppConstants, DataFormats, shotChannels, ViewModes } from 'utils/constants';
import { logger } from 'utils/logger';

const useStyles = createStyles((theme) => ({
    distCard: {
        border: `1px solid`,
        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.white,
        padding: theme.spacing.md,
    },
}));
const SeasonEdit = ({ season = new SeasonModel(), mode = ViewModes.EDIT, onCancel, onSave }) => {
    const [active, handlers] = useDisclosure(false);
    const [tags, setTags] = useState([]);
    const dispatch = useDispatch();
    const [distSelections, setDistSelections] = useState([]);
    const { classes } = useStyles();
    const form = useForm({
        initialValues: {
            ...season,
        },

        validate: {
            // email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        },
    });

    useEffect(() => {
        logger.log(active);
        if (!active) {
            logger.log('toggling focus ');
            setTimeout(() => {
                handlers.toggle();
            }, 1000);
        }
    }, [active, handlers]);

    /**
     * Function to submit values to create a new season
     * @param {*} values
     */
    const formHandler = (values) => {
        const tmpTags = tags.join(', ');
        const payload = { ...values, tags: values.tags.join(', ')
            , channel: values.channel
            , channels: values.channel };
            // , channels: values.channels.join(',') };

        logger.log(payload, 'payload');

        dispatch(createSeason(payload));
    };


    const onDistTypeClick = (type) => {
        setDistSelections([type]);
    };

    const disabled = mode === ViewModes.VIEW ? true : false;
    return (
        <>
            {mode === ViewModes.VIEW ? (
                <Stack spacing={0}>
                    <FormInputWrapper labelWidth={100} label='Name:' id='input-sku'>
                        <Text pt={4} size={'sm'}>
                            {form.values.name}
                        </Text>
                    </FormInputWrapper>

                    <FormInputWrapper labelWidth={100} label='Description:' id='input-desc'>
                        <Text pt={4} size={'sm'}>
                            {form.values.description}
                        </Text>
                    </FormInputWrapper>

                    <FormInputWrapper labelWidth={100} label='Tags' id='input-tags'>
                        <Text pt={4} size={'sm'} color={form.values.tags.length ? '' : 'dimmed'}>
                            {form.values.tags.length ? form.values.tags : 'No Tags'}
                        </Text>
                    </FormInputWrapper>

                    <FormInputWrapper labelWidth={100} label='Channel'>
                        <Box pt={4}>
                            <ChannelBadge channels={form.values.channels?.length ? form.values.channels : form.values.channel} />
                        </Box>
                    </FormInputWrapper>

                    <FormInputWrapper labelWidth={100} label='Deadline'>
                        <Box>
                            <Badge>
                                <Moment fromNow>{form.values.deadline}</Moment>
                            </Badge>
                            <Text pt={4} size={'sm'}>
                                <Moment format={DataFormats.DATE_FORMAT}>{form.values.deadline}</Moment>
                            </Text>
                        </Box>
                    </FormInputWrapper>
                </Stack>
            ) : (
                <form onSubmit={form.onSubmit((values) => formHandler(values))}>
                    {/* <FocusTrap active={true}> */}
                    <FormInputWrapper label='Name' id='input-sku' required>
                        <Input id='input-name' data-autofocus required placeholder='Enter Name' variant={AppConstants.inputVariant} {...form.getInputProps('name')} />
                    </FormInputWrapper>

                    <FormInputWrapper label='Description' id='input-desc' required>
                        <Textarea id='input-desc' {...form.getInputProps('description')} placeholder='Description' variant={AppConstants.inputVariant} />
                    </FormInputWrapper>

                    

                    <FormInputWrapper label='Deadline' id='input-tags' required>
                        <Group>
                            <CustomDatePicker required withAsterisk placeholder='Due Date' {...form.getInputProps('deadline')} />
                        </Group>
                    </FormInputWrapper>
                    {/* channels */}

                    <FormInputWrapper label='Channel' id='input-channel' required description='Select the channel for the Session'>
                        <Radio.Group mt={4} {...form.getInputProps('channel')}>
                            <Stack spacing='xs'>
                                {shotChannels.map((channel) => (
                                    <Radio
                                        key={channel.value}
                                        value={channel.value}
                                        label={
                                            <Group spacing='xs' noWrap>
                                                <ThemeIcon size='sm' variant='light' color={channel.color}>
                                                    {channel.icon}
                                                </ThemeIcon>
                                                <Text size='sm'>{channel.label}</Text>
                                            </Group>
                                        }
                                    />
                                ))}
                            </Stack>
                        </Radio.Group>
                    </FormInputWrapper>

                    {/* <FormInputWrapper label='Channels' id='input-channels' description='Select the channels for the Event'>
                        <Stack spacing="xs" mt={4}>
                            {shotChannels.map((channel, index) => (
                                <Checkbox
                                    key={index}
                                    label={channel.label}
                                    value={channel.value}
                                    checked={form.values.channels?.includes(channel.value) || false}
                                    onChange={(event) => {
                                        const currentChannels = form.values.channels || [];
                                        if (event.currentTarget.checked) {
                                            form.setFieldValue('channels', [...currentChannels, channel.value]);
                                        } else {
                                            form.setFieldValue('channels', currentChannels.filter(c => c !== channel.value));
                                        }
                                    }}
                                />
                            ))}
                        </Stack>
                    </FormInputWrapper> */}

{/* <Center py={'xl'}>
                        <SimpleGrid cols={3} mt='md' sx={{ maxWidth: 600 }}>
                            {shotChannels.map((item, idx) => {
                                const active = shotChannels.indexOf(item.value) > -1 ? true : false;
                                return (
                                    <Card key={idx} withBorder radius='md' p='md' className={active ? `${classes.distCard} active` : [classes.distCard]} onClick={() => onDistTypeClick(item.value)}>
                                        <Card.Section sx={{ height: 250, overflow: 'hidden' }}>
                                            <Image src={item.image} alt={item.title} height={250} />
                                        </Card.Section>

                                        <Card.Section className={classes.section} mt='md' px={'lg'} pb={'lg'}>
                                            <Group justify='apart'>
                                                <Text fz='lg' fw={500}>
                                                    {item.title}
                                                </Text>
                                            </Group>
                                            <Text fz='sm' mt='xs'>
                                                {item.description}
                                            </Text>
                                        </Card.Section>
                                        <Divider />
                                        <Card.Section className={classes.section} px={'lg'} pb={'lg'}>
                                            <Text mt='md' className={classes.label} c='dimmed'>
                                                Media Formats
                                            </Text>
                                            <Group gap={7} mt={'md'}>
                                                <Badge>webP</Badge>
                                                <Badge>jpeg</Badge>
                                                <Badge>tiff</Badge>
                                            </Group>
                                        </Card.Section>

              
                                    </Card>

                                    
                                );
                            })}
                        </SimpleGrid>
                    </Center> */}
                    <FormInputWrapper label='Tags' id='input-tags'>
                        <TagInput
                            {...form.getInputProps('tags')}
                            onChange={(val) => {
                                setTags([...val.map((item) => ({ value: item, label: item }))]);
                                form.setFieldValue('tags', val);
                            }}
                        />

                        {/* <MultiSelect
                            size='md'
                            data={tags}
                            placeholder='Enter Tags'
                            searchable
                            creatable
                            {...form.getInputProps('tags')}
                            getCreateLabel={(query) => `+ Create ${query}`}
                            onCreate={(query) => {
                                const item = { value: query, label: query };
                                setTags((current) => [...current, item]);
                                return item;
                            }}
                        /> */}
                    </FormInputWrapper>

                    <Group position='right' mt='md'>
                        <Button type='submit'>Create</Button>
                    </Group>
                    {/* </FocusTrap> */}
                    
                </form>
            )}
        </>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        success: state.seasonReducer.success,
        error: state.seasonReducer.error,
    };
};

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(SeasonEdit);
